import React from 'react';
import { Link } from 'react-router-dom';
import HistoryIcon from '@mui/icons-material/History';
import { Button, Divider, Stack } from '@mui/material';
import cx from 'classnames';

import './ItemGroupBar.scss';

export default function ItemGroupBar({ name, statusChip, historyLink, children, className }) {
  return (
    <div className={cx('item-group-bar', className)} data-testid="item-group-bar">
      <div className="item-group-bar-left">
        <h4 className="item-group-bar-name">{name}</h4>
        {statusChip && <div className="item-group-bar-status-chip">{statusChip}</div>}
        {children}
      </div>
      {historyLink && (
        <Stack direction="row" spacing={1}>
          <Button
            data-testid="ae-history-link"
            variant="text"
            startIcon={<HistoryIcon />}
            color="info"
            component={Link}
            to={historyLink}
          >
            History
          </Button>
          <Divider orientation="vertical" variant="middle" flexItem />
        </Stack>
      )}
    </div>
  );
}
